import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdiantamentoDetalharRoutingModule } from './adiantamento-detalhar-routing.module';
import { AdiantamentoDetalharComponent } from './adiantamento-detalhar.component';
import { FormsModule } from '@angular/forms';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@NgModule({
  declarations: [
    AdiantamentoDetalharComponent
  ],
  imports: [
    CommonModule,
    AdiantamentoDetalharRoutingModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    MessagesModule,
    DividerModule,
    TableModule,
    ProgressSpinnerModule

    
  ]
})
export class AdiantamentoDetalharModule { }
